// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

// PROOF DETAIL ADD FUNCTION
export const proofDetailsAdd = (proofData: any) => {
	const data = {
		AddBusinessTokenProof: proofData,
	};
	const url = `${API_URL}addBusinessProof`;
	return makeApiCall(url, data);
};

// FETCH PROOF DETAILS FUNCTION
export const fetchProofDetails = (fetchData: any) => {
	const data = {
		GetBusinessTokenProof: fetchData,
	};
	const url = `${API_URL}getBusinessProof`;
	return makeApiCall(url, data);
};

// UPDATE PROOF DETAILS FUNCTION
export const updateProofDetails = (updateData: any) => {
	const data = {
		UpdateProofDetailsToken: updateData,
	};
	const url = `${API_URL}updateBusinessProof`;
	return makeApiCall(url, data);
};

// DELETE PROOF DETAILS FUNCTION
export const deleteProofDetails = (deleteData: any) => {
	const data = {
		DeleteBusinessProofDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteBusinessProof`;
	return makeApiCall(url, data);
};
